import React from 'react'

import {
    UploadFile
} from '../common';

import {
    Dialog,
    Grid,
    IconButton,
    Typography,
    Paper,
} from '@material-ui/core';

import CloseIcon from '@material-ui/icons/Close';

export const UploadDialog = ({
    titleText,
    helpText,
    singleFile,
    uploadButtonText,
    removeButtonText,
    removeAllButtonText,
    disabled,
    uploadHandler,
    onFileDropHandler,
    open,
    handleClose,
    ...props }) => {
    return (
        <Dialog
            fullWidth={true}
            maxWidth="md"
            open={open}
            onClose={handleClose}
            style={{ zIndex: 20000 }}
        >
            <Paper style={{ backgroundColor: "#7957D5", color: "#fff", padding: 16, paddingLeft: 32, paddingRight: 32, borderRadius: 0, boxShadow: "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px" }}>
                <Grid container direction="row" justify="space-between" alignItems="center">
                    <Typography variant="h6">
                        {titleText ?? "Upload files"}
                    </Typography>
                    <IconButton
                        onClick={handleClose}>
                        <CloseIcon style={{ color: "#fff" }} />
                    </IconButton>
                </Grid>
            </Paper>
            <div style={{ padding: 32 }}>
                <UploadFile
                    height={88}
                    singleFile={singleFile}
                    disabled={disabled}
                    helpText={helpText}
                    uploadButtonText={uploadButtonText}
                    removeButtonText={removeButtonText}
                    removeAllButtonText={removeAllButtonText}
                    onFileDrop={onFileDropHandler}
                    upload={uploadHandler}
                />
            </div>
        </Dialog>
    )
}
